import { render } from "./SelecaoComponent.vue?vue&type=template&id=2b803c40&scoped=true&ts=true"
import script from "./SelecaoComponent.vue?vue&type=script&lang=ts"
export * from "./SelecaoComponent.vue?vue&type=script&lang=ts"

import "./SelecaoComponent.vue?vue&type=style&index=0&id=2b803c40&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b803c40"]])

export default __exports__